<template>
  <div>
    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/crm/guests">Guest profiles</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="active">View guest</li>
    </vs-breadcrumb>

    <div class="vx-row mb-6 mt-2">
      <div class="vx-col sm:w-2/5 w-full">
        <h2>Guest profile</h2>
      </div>
    </div>
    <vs-tabs position="left" class="tabs-shadow-none">
      <vs-tab icon-pack="feather" icon="icon-info" label="General">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <guest-profile-general />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-map-pin" label="Values">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <guest-values />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-map-pin" label="Consents">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <guest-profile-consents />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import GuestProfileGeneral from "./GuestProfileGeneral.vue";
import GuestValues from "./GuestValues.vue";
import GuestProfileConsents from "./GuestProfileConsents.vue";

export default {
  components: {
    GuestProfileGeneral,
    GuestProfileConsents,
    GuestValues,
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>